import gql from 'graphql-tag';

export const all = gql`query getCosts($fogId: ID!) {
    costs(fogId: $fogId){
        id
        creationDate
        invoiceNumber
        label
        totalCost
        url
        company {
            id
            name
        }
    }
}`;


export const get = gql`query getCost($id: ID!) {
    cost(id: $id){
    	id
        creationDate
        invoiceNumber
        label
        totalCost
        url
        company {
            id
            name
        }
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/cost.js